import { EdgeLoadMyEntitlementsRepository } from '@/modules/auth/infra/repositories'
import { makeSupabaseEdgeHttpClient } from '@/main/factories/http'
import type { LoadMyEntitlements } from '@/modules/auth/use-cases'

export function makeLoadMyEntitlements(): LoadMyEntitlements {
  return new EdgeLoadMyEntitlementsRepository(makeSupabaseEdgeHttpClient()).execute
}
